import { render, staticRenderFns } from "./ReleaseReposAdminTransfer.vue?vue&type=template&id=127d71a6&scoped=true&"
import script from "./ReleaseReposAdminTransfer.vue?vue&type=script&lang=js&"
export * from "./ReleaseReposAdminTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseReposAdminTransfer.vue?vue&type=style&index=0&id=127d71a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127d71a6",
  null
  
)

export default component.exports